/// <amd-module name="Artifacts/FeedPicker/redux/Sagas" />
import { FeedPickerActions, FeedPickerActionTypes } from "Artifacts/FeedPicker/redux/Actions";
import {
  IFeedPickerData,
  IFeedPickerService,
} from "Artifacts/FeedPicker/services/FeedPickerService";
import { call, getContext, put, takeEvery } from "Artifacts/Root/Saga";
import { SagaIterator } from "redux-saga";
import { IVssPageContext } from "VSS/Platform/Context";

export default function* rootSaga(): SagaIterator {
  yield takeEvery(FeedPickerActionTypes.LoadData, initializeData);
}

function* initializeData(): SagaIterator {
  try {
    yield put(FeedPickerActions.loadStarted());

    const context: IVssPageContext = (yield getContext("pageContext")) as any;
    const service: IFeedPickerService = context.getService("IFeedPickerService");
    const data: IFeedPickerData = (yield call(
      [service, service.getFeedPickerData],
      context,
    )) as any;

    yield put(FeedPickerActions.loadCompleted(data.feeds, data.deletedFeeds));
  } catch (error) {
    yield put(FeedPickerActions.loadFailed(error.message));
  }
}
